import React, { useState, useEffect } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";

const App = () => {
  const [locale, setLocale] = useState();

  const theme = createTheme(
    {
      scrollbarStyles: {
        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
          backgroundColor: "#38BDF8",
          borderRadius: 999,
        },
      },
      palette: {
        primary: { main: "#1E4E73", light: "#3B77A6", contrastText: "#ffffff" },
        secondary: { main: "#15B8A6", contrastText: "#0F172A" },
        background: {
          default: "#F3F6FB",
          paper: "#FFFFFF",
        },
        text: {
          primary: "#0F172A",
          secondary: "#475569",
        },
        success: { main: "#16A34A" },
        warning: { main: "#D97706" },
        error: { main: "#DC2626" },
      },
      shape: {
        borderRadius: 12,
      },
      typography: {
        fontFamily: '"Manrope","Segoe UI",sans-serif',
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        subtitle1: { fontWeight: 600 },
        button: { fontWeight: 600, letterSpacing: "0.01em" },
      },
      props: {
        MuiButton: {
          disableElevation: true,
        },
      },
      overrides: {
        MuiCssBaseline: {
          "@global": {
            "@import":
              'url("https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap")',
            "*": {
              boxSizing: "border-box",
            },
            html: {
              height: "100%",
            },
            body: {
              height: "100%",
              backgroundColor: "#F3F6FB",
              backgroundImage:
                "radial-gradient(circle at 12% 12%, rgba(56,189,248,0.18), transparent 45%), radial-gradient(circle at 86% 6%, rgba(21,184,166,0.15), transparent 42%)",
              color: "#0F172A",
            },
            "#root": {
              height: "100%",
            },
          },
        },
        MuiPaper: {
          rounded: {
            borderRadius: 16,
          },
          elevation1: {
            boxShadow: "0 12px 30px rgba(15, 23, 42, 0.08)",
          },
        },
        MuiAppBar: {
          colorPrimary: {
            backgroundColor: "#FFFFFF",
            color: "#0F172A",
            borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
            boxShadow: "none",
          },
        },
        MuiToolbar: {
          dense: {
            minHeight: 56,
          },
        },
        MuiDrawer: {
          paper: {
            backgroundImage:
              "linear-gradient(180deg, #225b7f 0%, #1a465f 100%)",
            color: "#E2E8F0",
            borderRight: "1px solid rgba(255,255,255,0.08)",
          },
        },
        MuiListItem: {
          root: {
            borderRadius: 10,
            margin: "4px 8px",
          },
        },
        MuiListItemIcon: {
          root: {
            color: "inherit",
            minWidth: 40,
          },
        },
        MuiButton: {
          root: {
            textTransform: "none",
            borderRadius: 10,
            padding: "8px 16px",
          },
          containedPrimary: {
            boxShadow: "0 10px 22px rgba(30, 78, 115, 0.25)",
          },
        },
        MuiTableCell: {
          head: {
            backgroundColor: "#F1F5F9",
            color: "#0F172A",
            fontWeight: 700,
            borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
          },
          body: {
            borderBottom: "1px solid rgba(15, 23, 42, 0.04)",
          },
        },
        MuiTableRow: {
          hover: {
            backgroundColor: "#F8FAFC",
          },
        },
        MuiOutlinedInput: {
          root: {
            borderRadius: 10,
            backgroundColor: "#FFFFFF",
          },
          notchedOutline: {
            borderColor: "rgba(148, 163, 184, 0.4)",
          },
        },
      },
    },
    locale
  );

  useEffect(() => {
    const i18nlocale = localStorage.getItem("i18nextLng");
    const browserLocale =
      i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

    if (browserLocale === "ptBR") {
      setLocale(ptBR);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Routes />
    </ThemeProvider>
  );
};

export default App;
